import { Component, Input, Output, EventEmitter, ViewChild, OnDestroy } from '@angular/core';
import { InfiniteScrollDirective, IInfiniteScrollEvent } from 'ngx-infinite-scroll';

@Component({
  selector: 'base-infinite-scroll',
  templateUrl: './base-infinite-scroll.component.html',
})
export class BaseInfiniteScrollComponent implements OnDestroy {
  @ViewChild(InfiniteScrollDirective) infiniteScrollDirective: any;

  @Input() throttle = 300;
  @Input() scrollDistance = 3;
  @Input() scrollUpDistance = 2;
  @Input() infiniteScrollDisabled = false;

  @Output() scrollDownEvent = new EventEmitter<IInfiniteScrollEvent>();

  ngOnDestroy() {
    this.infiniteScrollDirective.disposeScroller.unsubscribe();
    this.infiniteScrollDirective.setup();
  }
}
